// import Vue from 'vue'
import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import AppLink from '@/components/AppLink.vue'
// import { VueReCaptcha } from 'vue-recaptcha-v3'
// import VueScrollmagic from 'vue-scrollmagic'

// Vue.createApp(App)
const app = createApp(App)

app.config.unwrapInjectedRef = true;

app
  .component('AppLink', AppLink)
  .use(store)
  .use(router)
  // .use(VueReCaptcha, { siteKey: '6LcPf2AfAAAAAM5rav7Qb6CDEsZKxhSEAizero5g' })
  // .use(VueScrollmagic)
  .mount('#app')
